import React, { useEffect, useState } from "react";
import { Grid, Typography, Box } from "@mui/material";
import { fonts, themes } from "../../themes/themes";
import footer_logo from "../../../assets/images/footer_logo.png";
import "./footer.css";
import { useTranslation } from "react-i18next";
const Footer = (props: any) => {
  const { t } = useTranslation();
  const trans = t;
  return (
    <Grid
      container
      className="footer-main"
      style={{
        marginTop: "28px",
        marginBottom: props.marginbottom,
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box>
          <img src={footer_logo} />
        </Box>
        <Typography
          style={{
            fontFamily: fonts.fontFamily,
            color: themes.darkBlue,
            fontSize: fonts.title,
            paddingLeft: "1em",
          }}
        >
          {trans("Powered By")}{" "}
          <span
            style={{
              color: themes.primary,
              fontSize: fonts.title,
            }}
          >
            Cipherbizz
          </span>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Footer;
